/**
 * @generated SignedSource<<4e097a100155a1d01fab7bf0397fd447>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionHistoryScreenQuery$variables = {
  after?: string | null;
  first?: number | null;
  routineId: string;
  storeId?: string | null;
};
export type RoutineOccasionHistoryScreenQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionHistoryScreenList_Routine">;
  } | null;
};
export type RoutineOccasionHistoryScreenQuery = {
  response: RoutineOccasionHistoryScreenQuery$data;
  variables: RoutineOccasionHistoryScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineOccasionHistoryScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineOccasionHistoryScreenList_Routine"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineOccasionHistoryScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "RoutineOccasionConnection",
            "kind": "LinkedField",
            "name": "occasions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sequenceNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "calculateNoTasks",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "calculateNotCompletedStarted",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expireAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAtDate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "style",
                                "value": "DEFAULT"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "storeFormattedDate",
                            "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "filters": [
              "storeId"
            ],
            "handle": "connection",
            "key": "RoutineOccasionHistoryList_occasions",
            "kind": "LinkedHandle",
            "name": "occasions"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1d9293b4959f95dea20528682296bdc",
    "id": null,
    "metadata": {},
    "name": "RoutineOccasionHistoryScreenQuery",
    "operationKind": "query",
    "text": "query RoutineOccasionHistoryScreenQuery(\n  $routineId: ID!\n  $first: Int\n  $after: String\n  $storeId: ID\n) {\n  routine(id: $routineId) {\n    id\n    ...RoutineOccasionHistoryScreenList_Routine\n  }\n}\n\nfragment RoutineOccasionHistoryListItem_Occasion on RoutineOccasion {\n  id\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  startAtDate {\n    ...StoreFormattedDate\n  }\n  sequenceNumber\n}\n\nfragment RoutineOccasionHistoryScreenList_Routine on Routine {\n  id\n  occasions(first: $first, after: $after, storeId: $storeId) {\n    edges {\n      node {\n        id\n        sequenceNumber\n        ...RoutineOccasionHistoryListItem_Occasion\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n"
  }
};
})();

(node as any).hash = "8743c11ad7c6f964dff91e2f4a2e8901";

export default node;
